import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ItineraryHelperService {

  itineraryFormDefaultValues:any = null;

  constructor() { }

  private readonly storageKey = 'itineraryFormDefaultValues';

  setItineraryFormDefaultValues(defaultValues:any) {
    this.itineraryFormDefaultValues = defaultValues;
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(defaultValues));
    } catch (e) {
      console.warn('Unable to save itinerary defaults to localStorage', e);
    }
  }

  getItineraryFormDefaultValues() {
    if (this.itineraryFormDefaultValues) {
      return this.itineraryFormDefaultValues;
    }
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        this.itineraryFormDefaultValues = JSON.parse(stored);
      }
    } catch (e) {
      console.warn('Unable to read itinerary defaults from localStorage', e);
    }
    return this.itineraryFormDefaultValues;
  }
}